import { Modal, ModalOverlay, ModalContent, Flex, ModalBody, Text } from '@chakra-ui/react'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { IconWithinCircle } from '../../pages/Common/IconWithinCircle'

import checkIcon from '../../assets/check_white.svg'
import { Button, Column } from '@ubirider/pick-component-library'

export function SuccessModal({ title, description, isOpen, onOpen, onClose }) {
  const { t } = useTranslation()

  const initialRef = useRef(null)
  const finalRef = useRef(null)

  return (
    <Modal
      initialFocusRef={initialRef}
      finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      size={{ sm: 'xs', md: 'md', lg: 'xl', xl: 'xl' }}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Flex
            direction='column'
            align='center'
            justifyContent='center'
            p={{ sm: '24px 0px', md: '24px 0px', lg: '32px 56px', xl: '32px 56px' }}
            gap='32px'
          >
            <IconWithinCircle color='success.600' icon={checkIcon} />
            <Column css={{ gap: 8 }}>
              <Text fontWeight='700' fontSize='24px' color='neutral.800' align='center'>
                {t(title ?? 'authentication.success')}
              </Text>
              <Text fontWeight='600' fontSize='16px' color='neutral.600' align='center'>
                {description}
              </Text>
            </Column>
              <Button
                label={t('acqua_vias.common_ok')}
                type='success'
                style='solid'
                css={{ width: 152 }}
                onClick={onClose}
              />
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
